module.exports = __webpack_public_path__ + "media/images/top/qa/bg_hero_right-b8c535537212557fb8ea38fc3ae1a1dd.png";